import { useEffect, useRef } from 'react';
import { useSession } from '@/hooks/use-session';

interface PageViewLogOptions {
  event: string;
  entityId?: string;
  entityType: string;
  description?: string;
  url?: string;
}

/**
 * Logs a page view to SystemLog once per mount for all users (including guests).
 * Fire-and-forget — errors are silently ignored.
 */
export function usePageViewLog(options: PageViewLogOptions) {
  const { status } = useSession();
  const logged = useRef(false);

  useEffect(() => {
    if (status === 'loading' || logged.current) return;
    logged.current = true;

    const payload = JSON.stringify({
      event: options.event,
      entityId: options.entityId,
      entityType: options.entityType,
      description: options.description,
      url: options.url || window.location.pathname + window.location.search,
      // Landing referrer of the session; server stores it only when external.
      referrer: document.referrer || undefined,
    });
    fetch('/api/log/page-view', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  }, [
    status,
    options.event,
    options.entityId,
    options.entityType,
    options.description,
    options.url,
  ]);
}
